import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

export default function AdminAuthTitle({ title, subtitle }) {
  return (
    <>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{ fontWeight: 700, mb: subtitle ? 1 : 3, width: "100%" }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          color="text.secondary"
          textAlign="center"
          sx={{ mb: 3, width: "100%" }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  )
}

AdminAuthTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}
